import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeBE } from "../const";

export const SAFETY_CASE_REPORT_IMPORT_VALIDATE_CODE: {
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_DATA_NOT_EXIST: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_INVALID_FILE: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_WORKSPACE_CRF_NOT_EXIST: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_IMPORT_SPEC_NOT_EXIST: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_CRITERIA_ROW_NOT_EXIST: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REPORT_COLUMN_NOT_EXIST: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REPORT_IDENTIFIER_DUPLICATED: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REPORT_ATTRIBUTE_MISSING: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REPORT_SEQ_VALUE_INVALID: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REPEATABLE_NUMBER_FORMAT_INVALID: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_CASE_REPORT_MISSING: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REPORT_IS_EXIST: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REPORT_CONTENT_DUPLICATED: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_MISSING_ATTRIBUTE: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_PAGE_ID_NOT_EXIST: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_SECTION_ID_NOT_EXIST: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_ITEM_ID_NOT_EXIST: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_MAPPING_VALUE_NOT_EXIST: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_DATE_VALUE_INVALID: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_DATE_RANGE_INVALID: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_RELATED_TEXT_ITEM_INVALID_FORMAT: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_SINGLE_ROW_TYPE_TABLE_ITEM_INVALID_FORMAT: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_DICTIONARY_VERSION_INVALID: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_DICTIONARY_VERSION_MISSING: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_DICTIONARY_CODE_INVALID: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REPEATABLE_ITEM_DUPLICATED: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_IMPORT_DESTINATION_CASE_NOT_EXIST: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REPORT_TAG_NOT_EXIST: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_RELATED_ITEM_UUID_NOT_FOUND: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_RELATED_ITEM_UUID_DUPLICATE: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_DICTIONARY_VERSION_DUPLICATE: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_CODE_COMPARE_STRICT: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_NARRATIVE_FORMAT_INVALID: MvnCodeBE;
} = {
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_DATA_NOT_EXIST: {
    status: 400,
    ko: "유효한 데이터가 존재하지 않는 파일입니다.",
    en: "No valid data in file.",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_INVALID_FILE: {
    status: 400,
    ko: "유효하지 않은 형식의 파일입니다.",
    en: "Invalid file format.",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_WORKSPACE_CRF_NOT_EXIST: {
    status: 404,
    ko: "Workspace CRF 미존재 (crfId: {crfId})",
    en: "Workspace CRF does not exist (crfId: {crfId})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_IMPORT_SPEC_NOT_EXIST: {
    status: 400,
    ko: "Case report import spec 미존재 ({identifier})",
    en: "Case report import spec does not exist ({identifier})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_CRITERIA_ROW_NOT_EXIST: {
    status: 400,
    ko: "Import 기준 Row 미존재",
    en: "Import criteria row does not exist.",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REPORT_COLUMN_NOT_EXIST: {
    status: 400,
    ko: "Report 식별 컬럼 미존재",
    en: "Report identity column does not exist.",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REPORT_TAG_NOT_EXIST: {
    status: 400,
    ko: "Report 식별 태그 미존재",
    en: "Report identity tag does not exist.",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REPORT_IDENTIFIER_DUPLICATED: {
    status: 400,
    ko: "Import 파일 내 Report 중복 ({caseIdentifier}#{sequence})",
    en: "Duplicate Report in Import file (({caseIdentifier}#{sequence}))",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REPORT_ATTRIBUTE_MISSING: {
    status: 400,
    ko: "Report 일부 요소 누락 ({attribute})",
    en: "Missing report attribute ({attribute})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REPORT_SEQ_VALUE_INVALID: {
    status: 400,
    ko: "유효하지 않은 Report sequence 값",
    en: "Invalid Report sequence value",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REPEATABLE_NUMBER_FORMAT_INVALID: {
    status: 400,
    ko: "순서정렬 양식 오류 [{format}]",
    en: "Invalid Item sequence format [{format}]",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_CASE_REPORT_MISSING: {
    status: 400,
    ko: "{caseReportIdentifiers} 누락",
    en: "Missing {caseReportIdentifiers}",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REPORT_IS_EXIST: {
    status: 409,
    ko: "동일한 Case Report가 이미 존재합니다. ({caseIdentifier}#{sequence})",
    en: "Same Case Report is already exist ({caseIdentifier}#{sequence})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REPORT_CONTENT_DUPLICATED: {
    status: 409,
    ko: "중복 Content의 Report 존재 ({caseIdentifier}#{sequence} - patient name: {patientName}, product name: {productName}, adverse event: {adverseEvent})",
    en: "Existence of Report of Duplicate Content ({caseIdentifier}#{sequence} - patient name: {patientName}, product name: {productName}, adverse event: {adverseEvent})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_MISSING_ATTRIBUTE: {
    status: 400,
    ko: "일부 설정 값 누락으로 인한 검증 진행 불가",
    en: "Values cannot be verified because some setting values are missing",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_PAGE_ID_NOT_EXIST: {
    status: 400,
    ko: "존재하지 않는 Page ID ({pageId})",
    en: "Non-existent Page ID ({pageId})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_SECTION_ID_NOT_EXIST: {
    status: 400,
    ko: "존재하지 않는 Section ID ({sectionId})",
    en: "Non-existent Section ID ({sectionId})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_ITEM_ID_NOT_EXIST: {
    status: 400,
    ko: "존재하지 않는 Item ID ({itemId})",
    en: "Non-existent Item ID ({itemId})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_MAPPING_VALUE_NOT_EXIST: {
    status: 400,
    ko: "정의되지 않은 Mapping 값 ({value})",
    en: "Undefined Mapping Value ({value})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_DATE_VALUE_INVALID: {
    status: 400,
    ko: "범위를 초과한 날짜 ({range})",
    en: "Date out of range ({range})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_DATE_RANGE_INVALID: {
    status: 400,
    ko: "범위를 초과한 날짜 (itemId: {itemId}, range: {range})",
    en: "Date out of range (itemId: {itemId}, range: {range})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_RELATED_TEXT_ITEM_INVALID_FORMAT: {
    status: 400,
    ko: "잘못된 형식 ({value})",
    en: "Invalid format ({value})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_DICTIONARY_VERSION_INVALID: {
    status: 404,
    ko: "유효하지 않은 dictionary version (dictionary: {type}, version: {version})",
    en: "Invalid dictionary version (dictionary: {type}, version: {version})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_DICTIONARY_VERSION_MISSING: {
    status: 404,
    ko: "{dictionary} 버전 입력 누락",
    en: "Missing {dictionary} version",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_DICTIONARY_CODE_INVALID: {
    status: 400,
    ko: "{version} 내 존재하지 않는 {codeLabel}({code})",
    en: "{code} missing in {version} version",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_IMPORT_DESTINATION_CASE_NOT_EXIST: {
    status: 400,
    ko: "{caseReport}를 import 하고자 하는 위치에 Case({case})가 존재하지 않습니다.",
    en: "Case({case}) does not exist where you want to import {caseReport}",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REPEATABLE_ITEM_DUPLICATED: {
    status: 400,
    ko: "Cell 내의 '{prefix}' 중복",
    en: "Duplicate '{prefix}' in cell",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_RELATED_ITEM_UUID_NOT_FOUND: {
    status: 400,
    ko: "Related item uuid 누락 (itemId: {itemId})",
    en: "Missing related item uuid (itemId: {itemId})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_RELATED_ITEM_UUID_DUPLICATE: {
    status: 400,
    ko: "Related item uuid 중복 (uuid: {uuid})",
    en: "Duplicate related item uuid (uuid: {uuid})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_DICTIONARY_VERSION_DUPLICATE: {
    status: 400,
    ko: "Dictionary version 중복 (dictionary: {type})",
    en: "Duplicate dictionary version (dictionary: {type})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_SINGLE_ROW_TYPE_TABLE_ITEM_INVALID_FORMAT: {
    status: 400,
    ko: "{itemLabel}은(는) 1개만 입력할 수 있습니다.",
    en: "Only one of {itemLabel} can be entered.",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_CODE_COMPARE_STRICT: {
    status: 400,
    ko: "대소문자 구분 필요 (itemId: {itemId})",
    en: "Case must match exactly (itemId: {itemId})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_NARRATIVE_FORMAT_INVALID: {
    status: 400,
    ko: "최대 글자 수 초과 ({currentLength}/{maxlen})",
    en: "Maximum characters exceeded ({currentLength}/{maxlen})",
  },
};

export const SAFETY_CASE_REPORT_IMPORT_VALIDATE_EXCEL_CODE: {
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_VALUE_FORMAT_INVALID: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_VALUE_EDGE_WHITESPACE_INVALID: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_NULL_FLAVOR_FORMAT_INVALID: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_DATE_FORMAT_INVALID: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REQUIRED_ITEM_VALUE_MISSING: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_ITEM_NOT_AVAILABLE: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REPEATABLE_ITEM_REF_NOT_FOUND: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_PARENT_ITEM_NOT_FOUND: MvnCodeBE;
} = {
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_VALUE_FORMAT_INVALID: {
    status: 400,
    ko: "올바르지 않은 데이터 입력 형식 ({value})",
    en: "Invalid data entry format ({value})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_VALUE_EDGE_WHITESPACE_INVALID: {
    status: 400,
    ko: "앞뒤 공백 입력 불가 항목",
    en: "Not allowed leading/trailing whitespace",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_DATE_FORMAT_INVALID: {
    status: 400,
    ko: "잘못된 날짜 형식 ({value})",
    en: "Invalid date format ({value})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_NULL_FLAVOR_FORMAT_INVALID: {
    status: 400,
    ko: "허용하지 않는 Null Flavor ({value})",
    en: "Not allowed Null Flavor ({value})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REQUIRED_ITEM_VALUE_MISSING: {
    status: 400,
    ko: "필수값 누락 (label: {itemLabel})",
    en: "Missing required item value (label: {itemLabel})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_ITEM_NOT_AVAILABLE: {
    status: 400,
    ko: "입력 불가 항목",
    en: "Unavailable item",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REPEATABLE_ITEM_REF_NOT_FOUND: {
    status: 400,
    ko: "존재하지 않는 참조 값 (Name: {itemId}, RefId : [{prefix}])",
    en: "Reference value does not exist (Name: {itemId}, RefId: [{prefix}])",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_PARENT_ITEM_NOT_FOUND: {
    status: 400,
    ko: "{parentSheetName}에 존재하지 않는 Case ({caseIdentifierAndSequence})",
    en: "Case ({caseIdentifierAndSequence}) does not exist in {parentSheetName}",
  },
};

export const SAFETY_CASE_REPORT_IMPORT_VALIDATE_XML_CODE: {
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_VALUE_FORMAT_INVALID: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_VALUE_EDGE_WHITESPACE_INVALID: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_NULL_FLAVOR_INVALID: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_DATE_FORMAT_INVALID: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REQUIRED_ITEM_VALUE_MISSING: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_ITEM_NOT_AVAILABLE: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_RELATED_ITEM_NOT_FOUND: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REPEAT_UUID_NOT_FOUND_BY_XPATH: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_NARRATIVE_FORMAT_INVALID: MvnCodeBE;
} = {
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_VALUE_FORMAT_INVALID: {
    status: 400,
    ko: "올바르지 않은 데이터 입력 형식 (itemId: {itemId}, value: {value})",
    en: "Invalid data entry format (itemId: {itemId}, value: {value})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_VALUE_EDGE_WHITESPACE_INVALID: {
    status: 400,
    ko: "앞뒤 공백 입력 불가 항목 (itemId: {itemId})",
    en: "Not allowed leading/trailing whitespace (itemId: {itemId})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_DATE_FORMAT_INVALID: {
    status: 400,
    ko: "잘못된 날짜 형식 (itemId: {itemId}, value: {value})",
    en: "Invalid date format (itemId: {itemId}, value: {value})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_NULL_FLAVOR_INVALID: {
    status: 400,
    ko: "허용하지 않는 Null Flavor (itemId: {itemId}, value: {value})",
    en: "Not allowed Null Flavor (itemId: {itemId}, value: {value})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REQUIRED_ITEM_VALUE_MISSING: {
    status: 400,
    ko: "필수값 누락 (itemId: {itemId})",
    en: "Missing required item value (itemId: {itemId})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_ITEM_NOT_AVAILABLE: {
    status: 400,
    ko: "입력 불가 항목 (itemId: {itemId})",
    en: "Unavailable item (itemId: {itemId})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_RELATED_ITEM_NOT_FOUND: {
    status: 400,
    ko: "존재하지 않는 참조 값 (itemId: {itemId})",
    en: "Reference value does not exist (itemId: {itemId})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REPEAT_UUID_NOT_FOUND_BY_XPATH: {
    status: 400,
    ko: "XPath에 해당하는 반복(Repeat) UUID를 찾을 수 없습니다. (xpath: {xpath})",
    en: "Repeat UUID not found by XPath. (xpath: {xpath})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_NARRATIVE_FORMAT_INVALID: {
    status: 400,
    ko: "최대 글자 수 초과 (itemId: {itemId}) ({currentLength}/{maxlen})",
    en: "Maximum characters exceeded (itemId: {itemId}) ({currentLength}/{maxlen})",
  },
};

export const SAFETY_CASE_REPORT_IMPORT_VALIDATE_MFDS_CODE: {
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REQUIRED_REPORT_INFO_MISSING: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_INVALID_REPEATABLE_KEY_VALUE: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_CASE_IS_EXIST: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_VALUE_FORMAT_INVALID: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_VALUE_EDGE_WHITESPACE_FORMAT_INVALID: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_MAPPING_VALUE_NOT_EXIST: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REQUIRED_REPORT_COMPLETION_DATE_MISSING: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_RELATED_TEXT_BIND_TO_VALUE_MISSING: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REPEATABLE_KEY_NOT_FOUND: MvnCodeBE;
} = {
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REQUIRED_REPORT_INFO_MISSING: {
    status: 400,
    ko: "보고서 정보 누락 (보고자 식별자, 보고 생성일, 보고 완료일, 접수번호)",
    en: "Missing report information (Sender Report Identifier, Report Created Time, Report Completion Date, Department Receipt Number)",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_INVALID_REPEATABLE_KEY_VALUE: {
    status: 400,
    ko: "반복 키 값의 형식이 올바르지 않습니다. 입력하신 키({key})와 값({value})을 다시 한 번 확인해주세요.",
    en: "Invalid repeatable key value format (key: {key}, value: {value})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_CASE_IS_EXIST: {
    status: 400,
    ko: "동일한 Case가 이미 존재합니다. (caseIdentifier: {caseIdentifier})",
    en: "Case already exists (caseIdentifier: {caseIdentifier})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_VALUE_FORMAT_INVALID: {
    status: 400,
    ko: "입력하신 데이터의 형식이 올바르지 않습니다. 입력하신 값({value})을 다시 한 번 확인해주세요. (Item ID: {itemId})",
    en: "Invalid data entry format. Please check the value({value}) you entered. (Item ID: {itemId})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_VALUE_EDGE_WHITESPACE_FORMAT_INVALID: {
    status: 400,
    ko: "앞뒤 공백을 입력할 수 없는 항목입니다. 입력하신 값을 다시 한 번 확인해주세요. (Item ID: {itemId})",
    en: "Leading/trailing whitespace is not allowed. Please check the value you entered. (Item ID: {itemId})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_MAPPING_VALUE_NOT_EXIST: {
    status: 400,
    ko: "입력하신 값({value})은 지원하지 않는 값입니다. 매핑 정의를 다시 한 번 확인해주세요. (Item ID: {itemId})",
    en: "The value({value}) you entered is an undefined mapping value. Please check the mapping definition again. (Item ID: {itemId})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_RELATED_TEXT_BIND_TO_VALUE_MISSING: {
    status: 400,
    ko: "참조하려는 Item 값을 찾을 수 없습니다. (Item ID: {itemId})",
    en: "The value of the item you want to reference cannot be found. (Item ID: {itemId})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REQUIRED_REPORT_COMPLETION_DATE_MISSING: {
    status: 400,
    ko: "보고서 완료일 누락",
    en: "Missing Report Completion Date",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REPEATABLE_KEY_NOT_FOUND: {
    status: 400,
    ko: "{colName}의 값이 존재하지 않습니다.",
    en: "The value of {colName} does not exist.",
  },
};

export const SAFETY_CASE_REPORT_IMPORT_VALIDATE_KAERS_CODE: {
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_VALUE_FORMAT_INVALID: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_DUPLICATE_FILE_NAME_FOUND: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_MISSING_REQUIRED_FILES: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_INVALID_FILE_HEADER: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_INVALID_FILE_HEADER_FIELD_COUNT_MISMATCH: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_INVALID_FILE_HEADER_FIELD_NAME_MISMATCH: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_INVALID_FILE_HEADER_OR_BODY: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_EMPTY_CONTENT_IN_FILE: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_EMPTY_LINE_BETWEEN_HEADER_AND_BODY: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_EMPTY_MIDDLE_LINE_IN_BODY: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_RELATED_SEQUENCE_NOT_FOUND: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_RELATED_ITEM_VALUE_NOT_FOUND: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_DATE_FORMAT_INVALID: MvnCodeBE;
  // TODO: 추후 xml과 함께 공통으로 변경 필요 (2025.11.18)
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_ITEM_NOT_AVAILABLE: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REQUIRED_ITEM_VALUE_MISSING: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_CODE_COMPARE_STRICT: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_MAPPING_VALUE_NOT_EXIST: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_DATE_RANGE_INVALID: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_SINGLE_ROW_TYPE_TABLE_ITEM_INVALID_FORMAT: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_SCHEMA_REPEAT_SEQUENCE_MISSING: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_SCHEMA_REPEAT_SEQUENCE_NOT_SEQUENTIAL: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_KAERS_NO_NOT_FOUND_IN_GROUP: MvnCodeBE;
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_ROW_LIMIT_EXCEED: MvnCodeBE;
} = {
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_VALUE_FORMAT_INVALID: {
    status: 400,
    ko: "올바르지 않은 데이터 입력 형식 (correctFormat: {correctFormat}, value: {value})",
    en: "Invalid data entry format (correctFormat: {correctFormat}, value: {value})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_DUPLICATE_FILE_NAME_FOUND: {
    status: 400,
    ko: "중복된 파일 이름이 존재합니다. ({fileName})",
    en: "Duplicate file name found. ({fileName})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_MISSING_REQUIRED_FILES: {
    status: 400,
    ko: "필수 파일이 누락되었습니다. ({files})",
    en: "Missing required files. ({files})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_INVALID_FILE_HEADER: {
    status: 400,
    ko: "유효하지 않은 파일 헤더입니다. ({fileName})",
    en: "Invalid file header. ({fileName})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_INVALID_FILE_HEADER_FIELD_COUNT_MISMATCH: {
    status: 400,
    ko: "파일 헤더 필드 수가 일치하지 않습니다. (fileName:{fileName}, expected:{expected}, actual:{actual})",
    en: "File header field count mismatch. (fileName:{fileName}, expected:{expected}, actual:{actual})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_INVALID_FILE_HEADER_FIELD_NAME_MISMATCH: {
    status: 400,
    ko: "파일 헤더 필드 이름이 일치하지 않습니다. (fileName:{fileName}, expected:{expected}, actual:{actual})",
    en: "File header field name mismatch. (fileName:{fileName}, expected:{expected}, actual:{actual})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_INVALID_FILE_HEADER_OR_BODY: {
    status: 400,
    ko: "파일 헤더 또는 본문이 유효하지 않습니다. ({fileName})",
    en: "File header and body is invalid. ({fileName})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_EMPTY_CONTENT_IN_FILE: {
    status: 400,
    ko: "파일 내용이 비어있습니다. ({fileName})",
    en: "File content is empty. ({fileName})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_EMPTY_LINE_BETWEEN_HEADER_AND_BODY: {
    status: 400,
    ko: "파일 헤더와 본문 사이에 빈 줄이 존재합니다. ({fileName})",
    en: "There is an empty line between the file header and body. ({fileName})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_EMPTY_MIDDLE_LINE_IN_BODY: {
    status: 400,
    ko: "파일 본문에 빈 줄이 존재합니다. ({fileName})",
    en: "There is an empty line in the file body. ({fileName})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_RELATED_SEQUENCE_NOT_FOUND: {
    status: 400,
    ko: "참조해야할 시퀀스 정보를 찾을 수 없습니다. (relatedSchemaName: {relatedSchemaName}, relatedRepeatKeyFieldName: {relatedRepeatKeyFieldName}, sequence: {sequence})",
    en: "Related sequence information not found. (relatedSchemaName: {relatedSchemaName}, relatedRepeatKeyFieldName: {relatedRepeatKeyFieldName}, sequence: {sequence})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_RELATED_ITEM_VALUE_NOT_FOUND: {
    status: 400,
    ko: "참조하려는 Item 값을 찾을 수 없습니다. (relatedSchemaName: {relatedSchemaName}, relatedRepeatKeyFieldName: {relatedRepeatKeyFieldName}, sequence: {sequence})",
    en: "The value of the item you want to reference cannot be found. (relatedSchemaName: {relatedSchemaName}, relatedRepeatKeyFieldName: {relatedRepeatKeyFieldName}, sequence: {sequence})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_DATE_FORMAT_INVALID: {
    status: 400,
    ko: "잘못된 날짜 형식 (value: {value})",
    en: "Invalid date format (value: {value})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_ITEM_NOT_AVAILABLE: {
    status: 400,
    ko: "입력 불가 항목",
    en: "Unavailable item",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_REQUIRED_ITEM_VALUE_MISSING: {
    status: 400,
    ko: "필수값 누락 ({label})",
    en: "Missing required item value ({label})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_CODE_COMPARE_STRICT: {
    status: 400,
    ko: "대소문자 구분 필요 (value: {value})",
    en: "Case must match exactly (value: {value})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_MAPPING_VALUE_NOT_EXIST: {
    status: 400,
    ko: "존재하지 않는 매핑 값 (value: {value})",
    en: "Mapping value does not exist (value: {value})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_BIND_TO_DATE_RANGE_INVALID: {
    status: 400,
    ko: "잘못된 날짜 범위 (range: {range})",
    en: "Invalid date range (range: {range})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_SINGLE_ROW_TYPE_TABLE_ITEM_INVALID_FORMAT: {
    status: 400,
    ko: "{itemLabel}은(는) 1개만 입력할 수 있습니다.",
    en: "Only one of {itemLabel} can be entered.",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_SCHEMA_REPEAT_SEQUENCE_MISSING: {
    status: 400,
    ko: "반복 시퀀스 값은 필수입니다.",
    en: "The repeat sequence value is required.",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_SCHEMA_REPEAT_SEQUENCE_NOT_SEQUENTIAL: {
    status: 400,
    ko: "반복 시퀀스 값이 1씩 증가하는 순서로 입력되어야 합니다. (lastSeq: {lastSeq}, seq: {seq})",
    en: "The repeat sequence value must be input in sequential order by 1. (lastSeq: {lastSeq}, seq: {seq})",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_KAERS_NO_NOT_FOUND_IN_GROUP: {
    status: 400,
    ko: "GROUP에 KAERS_NO 값이 존재하지 않습니다.",
    en: "KAERS_NO value does not exist in GROUP.",
  },
  SAFETY_CASE_REPORT_IMPORT_VALIDATE_ERROR_ROW_LIMIT_EXCEED: {
    status: 400,
    ko: "파일 내 row 수가 제한을 초과했습니다. (rowLimit: {rowLimit})",
    en: "The number of rows in the file exceeds the limit. (rowLimit: {rowLimit})",
  },
};

MvnCodeInitiate(SAFETY_CASE_REPORT_IMPORT_VALIDATE_CODE);
MvnCodeInitiate(SAFETY_CASE_REPORT_IMPORT_VALIDATE_EXCEL_CODE);
MvnCodeInitiate(SAFETY_CASE_REPORT_IMPORT_VALIDATE_XML_CODE);
MvnCodeInitiate(SAFETY_CASE_REPORT_IMPORT_VALIDATE_MFDS_CODE);
MvnCodeInitiate(SAFETY_CASE_REPORT_IMPORT_VALIDATE_KAERS_CODE);
